@if (isOpen()) {
  <div
    class="modal-overlay"
    (click)="onOverlayClick()"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="title() ? 'modal-title' : null"
  >
    <div
      class="modal-container flex flex-col"
      (click)="onModalClick($event)"
      role="document"
      tabindex="0"
    >
      @if (showHeader()) {
        <div class="modal-header flex items-center justify-between shrink-0">
          <h6 class="modal-title flex-1" id="modal-title">{{ title() }}</h6>
          @if (showCloseButton()) {
            <button
              class="modal-close flex items-center justify-center shrink-0"
              (click)="onClose()"
              type="button"
              aria-label="Close modal"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          }
        </div>
      }

      <div class="modal-body flex flex-col flex-1 min-h-0">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
}
